import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { Reflector } from '../reflection';
export function Controller(metadata) {
  return function (Target) {
    Reflector.addControllerMetadata(Target, metadata);
    var proxy = new Proxy(Target, {
      construct: function construct(Target, args) {
        return Reflector.createDecoratedController.apply(Reflector, [Target].concat(_toConsumableArray(args)));
      }
    });
    Reflector.copyMetadata(Target, proxy);
    return proxy;
  };
}